import { tv } from '~/utils/tv'

export const checkboxVariants = tv({
  base: 'flex flex-col items-start justify-center gap-none rounded-pill font-rdmodern',
  variants: {
    size: {
      md: '',
      ml: '',
      lg: '',
      xl: '',
    },
    hasError: {
      true: 'h-full outline-none',
      false: '',
    },
    hasReadonly: {
      true: 'border-action-border-neutral-tertiary-readonly border-none bg-action-fill-neutral-tertiary-readonly',
      false: '',
    },
    hasDisabled: {
      true: 'border-none bg-action-fill-neutral-tertiary-disabled',
      false: '',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export const checkboxIconVariants = tv({
  base: 'flex items-center justify-center',
  variants: {
    size: {
      md: 'pr-onepulse',
      ml: 'pr-twopulse',
      lg: 'pr-twopulse',
      xl: 'pr-twopulse',
    },
  },
  defaultVariants: {
    size: 'md',
    hasLabelText: true,
  },
})

export const checkboxIconNoChildrenVariants = tv({
  base: 'flex items-center justify-center outline-none',
  variants: {
    size: {
      md: 'h-tiny w-tiny pr-none',
      ml: 'h-small w-small pr-none',
      lg: 'h-medium w-medium pr-none',
      xl: 'h-medium w-medium pr-none',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export const actionsVariants = tv({
  base: `
    mb-twopulse h-full cursor-pointer items-center justify-center rounded-pill
    p-halfpulse text-text-neutral bg-action-fill-neutral-tertiary-enabled [&:not(:focus-visisble)]:outline-none
  `,

  variants: {
    size: {
      md: '',
      ml: '',
      lg: '',
      xl: '',
    },
    hasError: {
      true: 'outline-none ring-forms-border-error ring-halfpulse focus:ring-forms-border-error',
      false: `
        hover:border-action-border-neutral-tertiary-hovered focus-visible:border-action-border-focused
         `,
    },
    hasDisabled: {
      true: `outline-none
            `,
    },
    hasReadonly: {
      true: `outline-none
            `,
    },
  },
  defaultVariants: {
    size: 'md',
  },
  compoundVariants: [
    {
      hasDisabled: false,
      hasReadonly: false,
      hasError: false,
      class: `
        focus-visible:ring-action-border-focused focus-visible:ring-halfpulse
      `,
    },
  ],
})

export const actionsContainerVariants = tv({
  base: `flex bg-action-fill-neutral-tertiary-enabled rounded-pill min-w-[128px] border-action-border-neutral-tertiary-enabled
  hover:bg-action-fill-neutral-tertiary-hovered hover:border-action-fill-neutral-tertiary-hovered outline-none
  `,
  variants: {
    size: {
      md: 'min-h-medium px-fourpulse py-onepulse',
      ml: 'min-h-mediumlarge px-fourpulse py-twopulse',
      lg: 'min-h-large px-fivepulse py-twopulse',
      xl: 'min-h-extralarge px-sixpulse py-threepulse',
    },
    hasReadonly: {
      true: `border-action-border-neutral-tertiary-readonly border-none bg-action-fill-neutral-tertiary-readonly text-text-neutral-readonly
            hover:bg-action-fill-neutral-tertiary-readonly active:bg-action-fill-neutral-tertiary-readonly
            outline-none
            `,
    },
    hasDisabled: {
      true: `border-action-border-neutral-tertiary-disabled border-none bg-action-fill-neutral-tertiary-disabled text-text-neutral-disabled
            hover:bg-action-fill-neutral-tertiary-disabled active:bg-action-fill-neutral-tertiary-disabled
            outline-none
            `,
    },
    hasError: {
      true: 'h-full outline-none',
      false: '',
    },
  },
  defaultVariants: {
    size: 'md',
  },
  compoundVariants: [
    {
      hasDisabled: false,
      hasReadonly: false,
      hasError: false,
      class: `
        active:bg-action-fill-neutral-tertiary-pressed active:border-none
        active:border-action-border-neutral-tertiary-pressed active:outline-none
        focus-visible:ring-action-border-focused focus-visible:ring-halfpulse [&:not(:focus-visisble)]:outline-none
      `,
    },
  ],
})

export const noChildrenVariants = tv({
  base: `w-full flex bg-action-fill-neutral-tertiary-enabled rounded-pill
  hover:bg-action-fill-neutral-tertiary-hovered
  active:bg-action-fill-neutral-tertiary-pressed active:border-action-border-neutral-tertiary-pressed outline-none`,
  variants: {
    size: {
      md: 'p-twopulse',
      ml: 'p-twopulse',
      lg: 'p-twopulse',
      xl: 'p-threepulse',
    },
    hasReadonly: {
      true: `border-action-border-neutral-tertiary-readonly border-none bg-action-fill-neutral-tertiary-readonly text-text-neutral-readonly
            hover:bg-action-fill-neutral-tertiary-readonly active:bg-action-fill-neutral-tertiary-readonly
            outline-none
            `,
    },
    hasDisabled: {
      true: `border-action-border-neutral-tertiary-disabled border-none bg-action-fill-neutral-tertiary-disabled text-text-neutral-disabled
            hover:bg-action-fill-neutral-tertiary-disabled active:bg-action-fill-neutral-tertiary-disabled outline-none`,
    },
    hasError: {
      true: 'h-full outline-none',
      false: '',
    },
  },
  defaultVariants: {
    size: 'md',
  },
  compoundVariants: [
    {
      hasDisabled: false,
      hasReadonly: false,
      hasError: false,
      class: `
         focus-visible:ring-action-border-focused focus-visible:ring-halfpulse
      `,
    },
  ],
})

export const helperTextVariants = tv({
  base: 'ml-halfpulse flex items-center bg-transparent',
  variants: {
    size: {
      md: 'px-fourpulse',
      ml: 'px-fourpulse',
      lg: 'px-fivepulse',
      xl: 'px-sixpulse',
    },
    hasError: {
      true: 'font-semibold text-threepulse leading-medium tracking-tiny',
      false: 'font-semibold text-threepulse leading-medium tracking-tiny',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export const helperTextNoChildrenVariants = tv({
  base: 'flex items-center bg-transparent',
  variants: {
    size: {
      md: 'px-threepulse',
      ml: 'px-fourpulse',
      lg: 'px-fivepulse',
      xl: 'px-sixpulse',
    },
    hasError: {
      true: 'font-semibold text-text-danger-alternative text-threepulse leading-medium tracking-tiny',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export const parentVariants = tv({
  base: 'flex flex-col pl-eightpulse',
  variants: {
    size: {
      md: '',
      ml: '',
      lg: '',
      xl: '',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
